import ErrorCode from './error-code';

const getErrorName = function (code: any) {
  for (const key in ErrorCode) {
    if (ErrorCode[key] === code) {
      return key;
    }
  }
  return 'UNKNOWN';
};
type ECT = typeof ErrorCode;
type EC = ECT[keyof ECT];
/**
 * RtcError 错误对象
 *
 * @extends Error
 * @class RtcError
 */
export class RtcError extends Error {
  code: EC;
  extraCode: number;
  message: string;
  // 原始错误信息
  originMessage: string;
  name: string;
  constraint: any;
  constructor({ name = 'RtcError', message, code = ErrorCode.UNKNOWN, extraCode = 0, constraint }: { name?: string, message: string, code: EC, extraCode?: number; constraint?: any; }) {
    const errorCodeString = `<${getErrorName(code)} 0x${code.toString(16)}>`;
    const msg = `${message
    }${constraint ? ` constraint: ${constraint}` : ''}` +
      `${message?.includes(errorCodeString) ? '' : ` ${errorCodeString}`}`; // 避免 message 出现重复的 <REMOTE_STREAM_NOT_EXIST 0x4010> 信息
    super(msg);
    this.code = code;
    // extra code for internal use only
    this.extraCode = extraCode;
    this.name = name;
    this.message = msg;
    this.constraint = constraint;
    this.originMessage = message;
  }

  /**
   * 获取错误码
   * <br>
   * 详细错误码列表参见 {@link module:ErrorCode ErrorCode}。
   *
   * @memberof RtcError
   */
  getCode() {
    return this.code;
  }

  // private
  getExtraCode() {
    return this.extraCode;
  }

  toString() {
    return this.originMessage;
  }
}
export default RtcError;
